/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['services/utils'], function(Utils) {
    'use strict';

    /**
     * @ignore
     * @param {String} sourceUrl
     * @param {String} paramName
     * @param {String} paramValue
     * @return {String}
     */
    function setQueryParamInUrl(sourceUrl, paramName, paramValue) {
        var qPrefix, pattern = new RegExp('(' + paramName + '=)[^&]*');
        if (pattern.test(sourceUrl)) {
            sourceUrl = sourceUrl.replace(pattern, '$1' + paramValue);
        } else {
            qPrefix = /\?/.test(sourceUrl) ? '&' : '?';
            sourceUrl += qPrefix + paramName + '=' + paramValue;
        }
        return sourceUrl;
    }

    /**
     * @ignore
     * Sets the value of a parameter in the given Url string.
     *
     * It does that in two form:
     *  1. Find and replace a token for this param in the Url
     *  2. If no token is found, appends the value as a query paremeter
     *
     * @param {String} sourceUrl
     * @param {String} paramName
     * @param {String} paramValue
     * @return {String} New Url string
     */
    function setParamInUrl(sourceUrl, paramName, paramValue) {
        var token;
        if (!Utils.isString(paramName) || !Utils.isString(paramValue) ||
        paramValue.trim().length === 0) {
            return sourceUrl;
        }
        token = new RegExp('{' + paramName + '}', 'g');
        if (token.test(sourceUrl)) {
            return sourceUrl.replace(token, paramValue);
        }
        return setQueryParamInUrl(sourceUrl, paramName, paramValue);
    }

    /**
     * @ignore
     * @param {String} sourceUrl
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {String} Parsed URL
     */
    function parseSourceUrl(sourceUrl, options) {
        // Replacing "key" token with API key
        sourceUrl = setParamInUrl(sourceUrl, 'key', options.apiKey);
        // Adding language query parameter
        if (options.language) {
            sourceUrl = setParamInUrl(sourceUrl, 'language', options.language);
        }
        // Adding geo-political view query parameter
        if (options.geopolView) {
            sourceUrl = setParamInUrl(sourceUrl, 'view', options.geopolView);
        }
        return sourceUrl;
    }

    /**
     * @ignore
     * @param {Object} source
     * @param {Object} [source.url]
     * @param {Object} [source.tiles]
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {Object}
     */
    function parseSourceUrls(source, options) {
        if (!Utils.isObject(source)) {
            return source;
        }
        if (source.hasOwnProperty('url') && Utils.isString(source.url)) {
            source.url = parseSourceUrl(source.url, options);
        }
        if (source.hasOwnProperty('tiles') && Utils.isArray(source.tiles)) {
            source.tiles = source.tiles.map(function(urlStr) {
                return parseSourceUrl(urlStr, options);
            });
        }
        return source;
    }

    /**
     * @ignore
     * Returns a new source's object with all the necessary changes to be compatible with the TomTom's Online Maps API.
     * @param {Object} sources
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @return {Object} New sources object
     */
    function parseSources(sources, options) {
        var sourceName, newSourcesObj = {};
        for (sourceName in sources) {
            if (sources.hasOwnProperty(sourceName)) {
                newSourcesObj[sourceName] = parseSourceUrls(sources[sourceName], options);
            }
        }
        return newSourcesObj;
    }

    /**
     * @ignore
     * Replace the {key} token with the real API key in the given style definition.
     *
     * @param {Object} styleDefinition Style definition object
     * @param {Object} [styleDefinition.sources]
     * @param {Object} options
     * @param {String} [options.apiKey]
     * @param {String} [options.language]
     * @param {String} [options.geopolView]
     * @param {Object} [options.resourcesUrls] Glyphs and sprite URLs to be used instead of
     *      those defined in the style definition
     * @param {String} [options.resourcesUrls.glyphs]
     * @param {String} [options.resourcesUrls.sprite]
     * @return {Object} New style definition object
     */
    function stylesParser(styleDefinition, options) {
        if (!Utils.isObject(styleDefinition)) {
            return styleDefinition;
        }

        // Parsing the style's sources
        if (Utils.isObject(styleDefinition.sources)) {
            styleDefinition.sources = parseSources(styleDefinition.sources, options);
        }

        // Replacing glyphs and sprite URLs if custom ones were passed to the L.Map constructor
        if (Utils.isObject(options.resourceUrls)) {
            if (options.resourceUrls.glyphs) {
                styleDefinition.glyphs = options.resourceUrls.glyphs;
            }
            if (options.resourceUrls.sprite) {
                styleDefinition.sprite = options.resourceUrls.sprite;
            }
        }

        return styleDefinition;
    }

    return stylesParser;
});



// WEBPACK FOOTER //
// ./display/layers/vector/stylesParser.js